import './ledgerLogoAssetFix.js';
import './ledgerPrintBrandingExact.js';
import './ledgerBrowserFooterFix.js';
import './barcodeScanBridge.js';
import './outletPaymentOutDeduper.js';

const params = new URLSearchParams(window.location.search);

if (params.get('barcode') === '1') {
  import('./barcode-entry.jsx');
} else {
  // POS is a normal ERP route now. It used to be hijacked here into a separate
  // ?pos=1 document running a second POS implementation (ModernPOSModule), which
  // meant the sidebar and the bottom nav opened two different POS screens. The
  // single implementation is POSWorkspace, rendered by main.jsx like any other page.
  import('./main.jsx').then(() => {
    document.addEventListener('click', (event) => {
      const parentButton = event.target.closest('button.vnav');
      if (!parentButton) return;
      const navGroup = parentButton.parentElement;
      window.setTimeout(() => {
        const firstChild = navGroup?.querySelector('.item-subnav button');
        if (firstChild && !firstChild.classList.contains('sub-on')) firstChild.click();
      }, 0);
    });
  });
}